import React, { lazy } from 'react';
import { ArrowUpRightIcon, InstagramIcon } from 'lucide-react';
const instagramPosts = [{
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=800&q=85',
  alt: 'Snow-covered Himalayan peaks above the Manaslu region'
}, {
  image: 'https://images.unsplash.com/photo-1519046904884-53103b34b206?auto=format&fit=crop&w=800&q=85',
  alt: 'Layered mountain ranges in the Himalaya'
}, {
  image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=800&q=85',
  alt: 'Forest trail in the Himalayan foothills'
}, {
  image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=800&q=85',
  alt: 'Jagged mountain ridge beneath a clear sky'
}, {
  image: 'https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=800&q=85',
  alt: 'Suspension bridge crossing a mountain valley'
}, {
  image: 'https://images.unsplash.com/photo-1486911278844-a81c5267e227?auto=format&fit=crop&w=800&q=85',
  alt: 'Prayer flags in a high Himalayan valley'
}, {
  image: 'https://images.unsplash.com/photo-1530789253388-582c481c54b0?auto=format&fit=crop&w=800&q=85',
  alt: 'Snowy peak above a remote mountain village'
}, {
  image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=800&q=85',
  alt: 'Dramatic Himalayan mountain pass'
}, {
  image: 'https://images.unsplash.com/photo-1472396961693-142e6e269027?auto=format&fit=crop&w=800&q=85',
  alt: 'Green mountain valley with a winding river'
}, {
  image: 'https://images.unsplash.com/photo-1605649487212-47bdab064df7?auto=format&fit=crop&w=800&q=85',
  alt: 'Kathmandu city surrounded by distant hills'
}];
const instagramUrl = 'https://www.instagram.com';
export function InstagramFeed() {
  return <section className="w-full bg-[#f7f4ec] py-20 text-[#1d2d2a] sm:py-28" aria-labelledby="instagram-feed-title" data-id="element-199" data-mp="213wsicwn03q2">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10" data-id="element-200" data-mp="1xzryrdlz6kd">
        <header className="flex flex-col gap-5 border-b border-[#c8c1af] pb-9 sm:flex-row sm:items-end sm:justify-between" data-id="element-201" data-mp="1wg70nh0c7c9">
          <div data-id="element-202" data-mp="3p2fnf6tnn7s4">
            <p className="eyebrow" data-id="element-203" data-mp="3p2z46k7kjq4k">From the trail</p>
            <h2 id="instagram-feed-title" className="mt-4 font-display text-4xl leading-tight sm:text-5xl" data-id="element-204" data-mp="3p4a7kix3qvv5">
              Follow the mountain moments.
            </h2>
          </div>
          <a href={instagramUrl} target="_blank" rel="noreferrer" className="inline-flex w-fit items-center gap-2 border-b border-[#6D5A39] pb-2 text-sm font-bold text-[#1d2d2a] transition-colors hover:text-[#6D5A39] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A48C5A] focus-visible:ring-offset-4" data-id="element-205" data-mp="gmnigj8lkq3g">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="2wcguv1g94sip" />
            @manaslutrekking
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="2mbo7d3whdrs1" />
          </a>
        </header>

        <div className="mt-8 grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3 lg:grid-cols-5" data-id="element-208" data-mp="2r97ocbkkcino">
          {instagramPosts.map((post, index) => <a key={post.image} href={instagramUrl} target="_blank" rel="noreferrer" aria-label={`View Manaslu Trekking Instagram post ${index + 1}`} className="group relative aspect-square overflow-hidden bg-[#e9e3d5] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A48C5A] focus-visible:ring-offset-4" data-id="element-209" data-mp="30z9bn153dx1j" data-mpi={index}>
              <img src={post.image} alt={post.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-210" data-mp="3jwk86dzcacda" />
              <span className="absolute inset-0 flex items-center justify-center bg-[#172a27]/0 text-[#f7f4ec] transition-colors duration-300 group-hover:bg-[#172a27]/50" data-id="element-211" data-mp="1plooogmm9cvq">
                <InstagramIcon className="h-6 w-6 opacity-0 transition-opacity duration-300 group-hover:opacity-100" aria-hidden="true" data-id="element-212" data-mp="3b0th5ystpgto" />
              </span>
            </a>)}
        </div>
      </div>
    </section>;
}